import "reflect-metadata";
import { Container, Factory } from "inversify";
import type {
  IAuthStore,
  IQueryClient,
  IRootStore,
  ISubscriptionStore,
  IWorkspaceStore,
} from "@workspace/types";
import { ServiceID } from "./symbols";

import { QueryClient } from "@tanstack/react-query";
import { RootStore } from "./root.store";
import { StoreQueryClient } from "./query-client";
import { AuthStore } from "./auth.store";
import { WorkspaceStore } from "./workspace.store";
import { SubscriptionManager } from "./subscription.store";

const container = new Container({ defaultScope: "Singleton" });

container.bind<IRootStore>(ServiceID.RootStore).to(RootStore);
container.bind<IQueryClient>(ServiceID.QueryClient).to(StoreQueryClient);
container.bind<IAuthStore>(ServiceID.AuthStore).to(AuthStore);
container.bind<IWorkspaceStore>(ServiceID.WorkspaceStore).to(WorkspaceStore);
container
  .bind<ISubscriptionStore>(ServiceID.SubscriptionStore)
  .to(SubscriptionManager);

export const sharedQueryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});

container
  .bind<Factory<IQueryClient>>(ServiceID.QueryClientFactory)
  .toFactory(
    (context) =>
      <TQueryFnData = unknown>(
        queryOptions: IQueryClient<TQueryFnData>["queryOptions"],
        queryClient?: QueryClient,
      ) => {
        const client = context.get<IQueryClient<TQueryFnData>>(
          ServiceID.QueryClient,
        );
        const _queryClient = queryClient || sharedQueryClient;

        client.queryOptions = queryOptions;
        client.queryClient = _queryClient;
        return client;
      },
  );

export { container, ServiceID, RootStore };
